import React, { useEffect, useRef } from 'react';
import { AuthState, withAuth } from 'context/auth';

interface Props {
  auth: AuthState;
}

const LoginButton_ = (props: Props): JSX.Element | null => {
  const googleLoginRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    props.auth.google &&
      props.auth.google.accounts.id.renderButton(googleLoginRef.current, {
        theme: 'filled_blue',
        size: 'large',
        text: 'signin',
        shape: 'pill',
        locale: 'en-US',
      });
  }, [props.auth.google]);

  return (
    <>
      <div ref={googleLoginRef}></div>
    </>
  );
};

const LoginButton = withAuth(LoginButton_);

export { LoginButton };
